import { render, staticRenderFns } from "./RouteAdding.vue?vue&type=template&id=415b89a8&"
import script from "./RouteAdding.vue?vue&type=script&lang=js&"
export * from "./RouteAdding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports